export enum Locales {
  EN = 'en',
  PT = 'pt',
  RU = 'ru',
  ES = 'es',
  IT = 'it',
  BT = 'pt-br',
}

export const LOCALES = [
  { value: Locales.EN, caption: 'English' },
  { value: Locales.RU, caption: 'Русский' },
  { value: Locales.PT, caption: 'Português Europeu' },
  { value: Locales.BT, caption: 'Português Brasileiro' },
  { value: Locales.ES, caption: 'Español' },
  { value: Locales.IT, caption: 'Italian' },
];

export const docs = {
  codeOfEthics: {
    path: '/docs/',
    lang: {
      ru: 'Ethic-Codex_RU.pdf',
      pt: 'Ethic-Codex_PT-EU.pdf',
      "pt-br": 'Ethic-Codex_PT-BT.pdf',
      es: 'Ethic-Codex_ESP.pdf',
      it: "Ethic-Codex_ITA.pdf",
      default: "Ethic-Codex_EN.pdf"
    }
  },

  contractOffer: {
    path: '/docs/',
    lang: {
      ru: 'ContractOffer_RU.pdf',
      pt: 'ContractOffer_PT-EU.pdf',
      "pt-br": 'ContractOffer_PT-BT.pdf',
      es: 'ContractOffer_ESP.pdf',
      it: "ContractOffer_ITA.pdf",
      default: "ContractOffer_EN.pdf"
    }
  },

  cookiePolicy: {
    path: '/docs/',
    lang: {
      ru: 'Cookie_Policy_RU.pdf',
      pt: 'Cookie_Policy_PT-EU.pdf',
      "pt-br": 'Cookie_policy_PT-BT.pdf',
      es: 'Cookie_policy_ESP.pdf',
      it: "Cookie_policy_ITA.pdf",
      default: "Cookie_Policy_EN.pdf"
    }
  },

  partnershipAgreement: {
    path: '/docs/',
    lang: {
      ru: 'PartnershipAgreement_RU.pdf',
      pt: 'PartnershipAgreement_PT-EU.pdf',
      "pt-br": 'PartnershipAgreement_PT-BT.pdf',
      es: 'PartnershipAgreement_ESP.pdf',
      it: "PartnershipAgreement_ITA.pdf",
      default: "PartnershipAgreement_EN.pdf"
    }
  },

  privacyPolicy: {
    path: '/docs/',
    lang: {
      ru: 'Privacy_Policy_RU.pdf',
      pt: 'Privacy_Policy_PT-EU.pdf',
      "pt-br": 'Privacy_Policy_PT-BT.pdf',
      es: 'Privacy_Policy_ESP.pdf',
      it: "Privacy_Policy_ITA.pdf",
      default: "Privacy_Policy_EN.pdf"
    }
  },

  taxObligationAgreement: {
    path: '/docs/',
    lang: {
      ru: 'TaxObligationAgreementDexFreedom_RU.pdf',
      pt: 'TaxObligationAgreementDexFreedom_PT_EU.pdf',
      "pt-br": 'TaxObligationAgreementDexFreedom_PT-BT.pdf',
      es: 'TaxObligationAgreementDexFreedom_ESP.pdf',
      it: "TaxObligationAgreementDexFreedom_ITA.pdf",
      default: "TaxObligationAgreementDexFreedom_EN.pdf"
    }
  },

  userAgreement: {
    path: '/docs/',
    lang: {
      ru: 'User_Agreement_RU.pdf',
      pt: 'User_Agreement_PT-EU.pdf',
      "pt-br": 'User_Agreement_PT-BT.pdf',
      es: 'User_Agreement_ESP.pdf',
      it: "User_Agreement_ITA.pdf",
      default: "User_Agreement_EN.pdf"
    }
  },
};

export function getDocLink(docKey, locale) {
  const doc = docs[docKey];
  if (!doc) {
    return '';
  }
  const filename = doc.lang[locale] ?? doc.lang.default;
  console.log(`${doc.path}${filename}`)
  return `${doc.path}${filename}`;
}
